import type { PlanReceipts, PlanSummary } from '@/lib/api';

/** The deck-level plan line, "Plan: Storm · Refund". Renders nothing when the deck has no plan. */
export function PlanLine({ plan }: { plan: PlanSummary | null | undefined }) {
  if (!plan || plan.archetypes.length === 0) return null;
  return (
    <div data-testid="plan-line" className="text-xs text-on-surface-variant">
      Plan: {plan.archetypes.map((a) => a.name).join(' · ')}
    </div>
  );
}

/** The top pull's first source's reason, composed by the backend; undefined when the card has no pull. */
export function planChipReason(receipts: PlanReceipts | null | undefined): string | undefined {
  return receipts?.pulls[0]?.sources[0]?.reason;
}
